import React, { useState } from 'react';
import axios from 'axios';
import API_URL from './config';
import './Login.css'; // Importa o arquivo CSS

function Login({ setToken, theme, onToggleTheme }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await axios.post(`${API_URL}/auth/login`, {
        username,
        password
      });

      setToken(response.data.token);

    } catch (err) {
      console.error('Erro no login:', err);
      setError('Login inválido');
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (field, value) => {
    if (field === 'username') setUsername(value);
    if (field === 'password') setPassword(value);
    if (error) setError(''); // Limpa o erro ao digitar
  };

  return (
    <div className="login-container">
      <button
        type="button"
        className="login-theme-toggle"
        onClick={onToggleTheme}
        title={theme === 'light' ? 'Mudar para tema escuro' : 'Mudar para tema claro'}
        aria-label="Alternar tema"
      >
        {theme === 'light' ? '🌙' : '☀️'}
      </button>
      <form className="login-card" onSubmit={handleSubmit} autoComplete="on">
        <div className="login-title">Bem-vindo!</div>
        <div className="login-subtitle">Acesse seu painel de chamadas</div>

        {error && <div className="login-error-message">{error}</div>}

        <div className="login-field">
          <label htmlFor="username" className="login-label">Usuário</label>
          <input
            className={`login-input ${error ? 'error' : ''}`}
            id="username"
            name="username"
            type="text"
            placeholder="Digite seu usuário"
            value={username}
            onChange={(e) => handleInputChange('username', e.target.value)}
            autoComplete="username"
            required
          />
        </div>

        <div className="login-field">
          <label htmlFor="password" className="login-label">Senha</label>
          <div className="password-input-wrapper">
            <input
              className={`login-input ${error ? 'error' : ''}`}
              id="password"
              name="password"
              type={showPassword ? "text" : "password"}
              placeholder="Digite sua senha"
              value={password}
              onChange={(e) => handleInputChange('password', e.target.value)}
              autoComplete="current-password"
              required
            />
            <button
              type="button"
              onClick={() => setShowPassword(v => !v)}
              className="toggle-password-button"
              tabIndex={-1}
              aria-label={showPassword ? "Ocultar senha" : "Mostrar senha"}
            >
              {showPassword
                ? <span role="img" aria-label="ocultar">🙈</span>
                : <span role="img" aria-label="mostrar">👁️</span>}
            </button>
          </div>
        </div>

        <button
          className="login-button"
          type="submit"
          disabled={loading || !username || !password}
        >
          {loading ? "Entrando..." : "Entrar"}
        </button>

        <div className="footer-text">
          © 2024 Sistema de Chamadas
        </div>
      </form>
    </div>
  );
}

export default Login;
